import Actions from '../../odata/actions';

const actions = new Actions('xeroOrganisation', 'xeroOrganisations');

export default actions;
